// SEO Configuration for OttoCollect - Ottoman Empire Banknotes
 
export const SEO_CONFIG = {
  // Default site-wide SEO
  default: {
    title: 'OttoCollect - Ottoman Empire Banknotes Catalog & Collectors Platform',
    description: 'OttoCollect is a comprehensive catalog and management platform dedicated to collectors of Ottoman Empire banknotes and those from successor countries since 1840. Our mission is to document and preserve numismatic history while supporting a vibrant community of collectors across Turkey, Jordan, Egypt, Lebanon, Palestine, Syria, Israel, Bulgaria, Albania, and beyond. Collectors can track personal collections, share images, contribute to the catalog, and connect with enthusiasts worldwide.',
    keywords: [
      'Ottoman Empire banknotes',
      'Turkish lira paper money',
      'historical currency',
      'rare banknotes',
      'collector banknotes',
      '1800s currency',
      'Ottoman currency',
      'Turkish banknotes',
      'vintage paper money',
      'numismatic collection'
    ]
  },

  // Long-tail keywords for different page types
  longTailKeywords: {
    // Home page
    home: [
      'authentic Ottoman Empire banknotes for collectors',
      'buy rare Ottoman currency from 1800s',
      'historical Turkish lira paper money for sale',
      'Ottoman Empire numismatic collection',
      'vintage Turkish banknotes for sale',
      'rare Ottoman paper money collectors',
      'authentic 19th century Turkish currency',
      'Ottoman Empire banknote marketplace',
      'historical currency trading platform',
      'collectible Ottoman banknotes online'
    ],

    // Catalog pages
    catalog: [
      'Ottoman Empire banknote catalog',
      'complete Turkish currency collection',
      'historical banknotes by country',
      'rare Ottoman paper money catalog',
      'authentic Turkish banknotes list',
      'vintage currency catalog online',
      'Ottoman Empire numismatic database',
      'collectible banknotes by region',
      'historical Turkish currency catalog',
      'rare paper money collection guide'
    ],


    contactUs: [
        'contact OttoCollect',
        'Ottoman banknote support',
        'collector assistance',
        'numismatic help',
        'banknote platform support'
      ],

    // Country-specific pages
    country: [
      'Ottoman Empire banknotes for sale',
      'Turkish Republic currency collection',
      'Palestine Mandate banknotes',
      'Syria historical currency',
      'Lebanon vintage banknotes',
      'Iraq Ottoman paper money',
      'Jordan historical currency',
      'Egypt Ottoman banknotes',
      'Greece Ottoman currency',
      'Bulgaria historical banknotes'
    ],

    // Banknote detail pages
    banknoteDetail: [
      'authentic Ottoman banknote verification',
      'rare Turkish currency authentication',
      'historical banknote condition guide',
      'Ottoman Empire paper money grading',
      'vintage Turkish banknote appraisal',
      'collectible currency market value',
      'Ottoman banknote preservation tips',
      'historical currency investment guide',
      'rare paper money authentication',
      'Turkish banknote collector tips'
    ],

    // Marketplace pages
    marketplace: [
      'buy Ottoman Empire banknotes online',
      'sell rare Turkish currency',
      'Ottoman banknote marketplace',
      'historical currency trading',
      'rare paper money for sale',
      'authentic Turkish banknotes buy',
      'vintage currency marketplace',
      'Ottoman Empire numismatic sales',
      'collectible banknote trading',
      'historical currency auction'
    ],

    // Collection pages
    collection: [
      'personal Ottoman banknote collection',
      'Turkish currency collection management',
      'historical banknote portfolio',
      'rare currency collection tracking',
      'Ottoman Empire numismatic inventory',
      'collectible banknote cataloging',
      'vintage currency collection display',
      'historical paper money portfolio',
      'Turkish banknote collection guide',
      'rare currency collection tips'
    ],

    // Blog/Educational content
    blog: [
      'how to authenticate Ottoman banknotes',
      'Ottoman Empire currency history',
      'Turkish banknote identification guide',
      'rare Ottoman paper money values',
      'historical currency preservation',
      'Ottoman Empire numismatic facts',
      'Turkish banknote collecting tips',
      'vintage currency investment advice',
      'Ottoman banknote grading guide',
      'historical Turkish currency guide'
    ]
  },

  // Page-specific SEO configurations
  pages: {
    home: {
      title: 'OttoCollect - Ottoman Empire Banknotes Catalog & Collectors Platform',
      description: 'OttoCollect is a comprehensive catalog and management platform dedicated to collectors of Ottoman Empire banknotes and those from successor countries since 1840. Our mission is to document and preserve numismatic history while supporting a vibrant community of collectors across Turkey, Jordan, Egypt, Lebanon, Palestine, Syria, Israel, Bulgaria, Albania, and beyond. Collectors can track personal collections, share images, contribute to the catalog, and connect with enthusiasts worldwide.',
      keywords: [
        'authentic Ottoman Empire banknotes for collectors',
        'buy rare Ottoman currency from 1800s',
        'historical Turkish lira paper money for sale',
        'Ottoman Empire numismatic collection',
        'vintage Turkish banknotes for sale',
        'rare Ottoman paper money collectors'
      ]
    },

    catalog: {
      title: 'OttoCollect - Ottoman Empire Banknotes Catalog & Collectors Platform',
      description: 'OttoCollect is a comprehensive catalog and management platform dedicated to collectors of Ottoman Empire banknotes and those from successor countries since 1840. Our mission is to document and preserve numismatic history while supporting a vibrant community of collectors across Turkey, Jordan, Egypt, Lebanon, Palestine, Syria, Israel, Bulgaria, Albania, and beyond. Collectors can track personal collections, share images, contribute to the catalog, and connect with enthusiasts worldwide.',
      keywords: [
        'Ottoman Empire banknote catalog',
        'complete Turkish currency collection',
        'historical banknotes by country',
        'rare Ottoman paper money catalog',
        'authentic Turkish banknotes list'
      ]
    },

    marketplace: {
      title: 'OttoCollect - Ottoman Empire Banknotes Catalog & Collectors Platform',
      description: 'Buy and sell authentic Ottoman Empire banknotes, rare Turkish currency, and historical paper money. Secure marketplace for serious collectors.',
      keywords: [
        'buy Ottoman Empire banknotes online',
        'sell rare Turkish currency',
        'Ottoman banknote marketplace',
        'historical currency trading',
        'rare paper money for sale'
      ]
    },

    collection: {
      title: 'OttoCollect - Ottoman Empire Banknotes Catalog & Collectors Platform',
      description: 'Organize and track your Ottoman Empire banknote collection. Catalog your rare Turkish currency, monitor values, and showcase your historical paper money.',
      keywords: [
        'personal Ottoman banknote collection',
        'Turkish currency collection management',
        'historical banknote portfolio',
        'rare currency collection tracking',
        'Ottoman Empire numismatic inventory'
      ]
    },

    forum: {
      title: 'Ottoman Banknote Collectors Forum',
      description: 'Join the OttoCollect community of Ottoman Empire banknote collectors. Discuss rare Turkish currency, share authentication tips, and connect with enthusiasts.',
      keywords: [
        'Ottoman banknote collectors forum',
        'Turkish currency discussion',
        'numismatic community',
        'banknote authentication tips',
        'collector networking'
      ]
    },

    blog: {
      title: 'Ottoman Banknote Blog - Education & History',
      description: 'Expert articles on Ottoman Empire banknotes, Turkish currency history, authentication guides, and numismatic education. Learn about rare paper money.',
      keywords: [
        'Ottoman banknote blog',
        'Turkish currency history',
        'numismatic education',
        'banknote authentication guides',
        'historical currency articles'
      ]
    },

    guide: {
      title: 'OttoCollect FAQ - Frequently Asked Questions',
      description: 'Answers to frequently asked questions about collecting Ottoman Empire and successor-state banknotes on OttoCollect — adding banknotes, managing your collection, grading, and suggesting catalogue images.',
      keywords: [
        'OttoCollect FAQ',
        'Ottoman banknote FAQ',
        'frequently asked questions',
        'how to collect Ottoman banknotes',
        'banknote collection help'
      ]
    },

    credits: {
      title: 'Credits & Links - OttoCollect',
      description: 'Useful links, references, and credits for the people and projects behind OttoCollect.',
      keywords: [
        'OttoCollect credits',
        'OttoCollect links',
        'numismatic resources',
        'banknote references'
      ]
    },

    community: {
      title: 'OttoCollect Community - Connect with Collectors',
      description: 'Join the OttoCollect community of Ottoman Empire banknote collectors. Connect with fellow enthusiasts, share knowledge, and grow your collection.',
      keywords: [
        'Ottoman banknote collectors community',
        'numismatic community',
        'collector networking',
        'banknote discussion forum',
        'collector messaging'
      ]
    },

    aboutUs: {
      title: 'About OttoCollect - Ottoman Banknote Platform',
      description: 'Learn about OttoCollect, the premier platform for Ottoman Empire banknote collectors. Discover our mission to preserve numismatic history and connect collectors.',
      keywords: [
        'about OttoCollect',
        'Ottoman banknote platform',
        'numismatic history preservation',
        'collector community platform',
        'Ottoman Empire currency collectors'
      ]
    },
    contactUs: {
      title: 'Contact OttoCollect - Ottoman Banknote Platform',
      description: 'Contact OttoCollect, the premier platform for Ottoman Empire banknote collectors. Get support, ask questions, and connect with our team.',
      keywords: [
        'contact OttoCollect',
        'Ottoman banknote platform',
        'numismatic history preservation',
        'collector community platform',
        'Ottoman Empire currency collectors'
      ]
    }
  },

  // Structured data templates
  structuredData: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "OttoCollect",
      "url": "https://ottocollect.com",
      "logo": "https://ottocollect.com/favicon-96x96.png",
      "description": "OttoCollect is a comprehensive catalog and management platform dedicated to collectors of Ottoman Empire banknotes and those from successor countries since 1840. Our mission is to document and preserve numismatic history while supporting a vibrant community of collectors across Turkey, Jordan, Egypt, Lebanon, Palestine, Syria, Israel, Bulgaria, Albania, and beyond. Collectors can track personal collections, share images, contribute to the catalog, and connect with enthusiasts worldwide.",
      "foundingDate": "2024",
      "sameAs": [
        "https://twitter.com/ottocollect",
        "https://facebook.com/ottocollect",
        "https://instagram.com/ottocollect"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "email": "support@ottocollect.com",
        "availableLanguage": "English"
      }
    },

    website: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "OttoCollect",
      "url": "https://ottocollect.com",
      "description": "OttoCollect is a comprehensive catalog and management platform dedicated to collectors of Ottoman Empire banknotes and those from successor countries since 1840. Our mission is to document and preserve numismatic history while supporting a vibrant community of collectors across Turkey, Jordan, Egypt, Lebanon, Palestine, Syria, Israel, Bulgaria, Albania, and beyond. Collectors can track personal collections, share images, contribute to the catalog, and connect with enthusiasts worldwide.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://ottocollect.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },

    breadcrumb: (items: Array<{name: string, url: string}>) => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": item.url
      }))
    })
  }
};

// Blog post ideas targeting long-tail keywords
export const BLOG_POST_IDEAS = [
  {
    title: "How to Authenticate 1908 Ottoman Banknotes: Guide",
    keywords: [
      "authenticate 1908 Ottoman banknotes",
      "Ottoman banknote authentication guide",
      "1908 Turkish currency verification",
      "Ottoman paper money authentication",
      "Turkish banknote authenticity check"
    ],
    description: "Learn expert techniques to authenticate 1908 Ottoman Empire banknotes. Discover security features, watermark identification, and professional grading methods for serious collectors."
  },
  {
    title: "Top 5 Most Valuable Ottoman Empire Currencies: 2024",
    keywords: [
      "most valuable Ottoman Empire currencies",
      "expensive Turkish banknotes",
      "rare Ottoman paper money values",
      "valuable Turkish currency list",
      "Ottoman banknote price guide"
    ],
    description: "Discover the top 5 most valuable Ottoman Empire banknotes in 2024. Expert analysis of rare Turkish currency values, market trends, and investment opportunities."
  },
  {
    title: "Ottoman Empire Banknote Watermarks: Identification Guide",
    keywords: [
      "Ottoman banknote watermarks",
      "Turkish currency watermark guide",
      "Ottoman paper money security features",
      "banknote watermark identification",
      "historical Turkish watermarks"
    ],
    description: "Master the identification of Ottoman Empire banknote watermarks. Comprehensive guide to Turkish currency security features and historical watermark development."
  },
  {
    title: "Rare 1876 Ottoman Banknotes: Historical Value",
    keywords: [
      "1876 Ottoman banknotes",
      "rare Turkish currency 1876",
      "historical Ottoman paper money",
      "1876 Turkish banknote value",
      "Ottoman Empire 1876 currency"
    ],
    description: "Explore the historical significance and collector value of rare 1876 Ottoman Empire banknotes. Expert analysis of this pivotal year in Turkish currency history."
  },
  {
    title: "Ottoman vs Turkish Republic Banknotes: Key Differences",
    keywords: [
      "Ottoman Empire vs Turkish Republic banknotes",
      "Turkish currency differences",
      "Ottoman vs Republic paper money",
      "Turkish banknote history comparison",
      "currency transition guide"
    ],
    description: "Compare Ottoman Empire and Turkish Republic banknotes. Learn key differences in design, security features, and historical context for informed collecting."
  },
  {
    title: "How to Grade Ottoman Banknotes: Professional Standards",
    keywords: [
      "grade Ottoman banknotes",
      "Turkish currency grading",
      "banknote condition guide",
      "Ottoman paper money grading",
      "numismatic grading standards"
    ],
    description: "Master the art of grading Ottoman Empire banknotes using professional numismatic standards. Essential guide for serious collectors and investors."
  },
  {
    title: "Palestine Mandate Banknotes: Ottoman Legacy Currency",
    keywords: [
      "Palestine Mandate banknotes",
      "Ottoman Palestine currency",
      "Mandate paper money",
      "Palestinian banknote history",
      "rare Middle Eastern currency"
    ],
    description: "Discover the fascinating history of Palestine Mandate banknotes and their connection to Ottoman Empire currency. Rare collectible insights for numismatic enthusiasts."
  },
  {
    title: "Ottoman Banknotes as Alternative Investment Assets",
    keywords: [
      "Ottoman banknotes investment",
      "Turkish currency investment",
      "alternative assets banknotes",
      "numismatic investment guide",
      "historical currency investment"
    ],
    description: "Learn how Ottoman Empire banknotes can serve as alternative investments. Expert analysis of market trends, risk factors, and portfolio diversification strategies."
  },
  {
    title: "Preservation Techniques for Ottoman Banknotes: Storage",
    keywords: [
      "preserve Ottoman banknotes",
      "Turkish currency preservation",
      "banknote storage techniques",
      "paper money conservation",
      "numismatic preservation guide"
    ],
    description: "Essential preservation techniques for Ottoman Empire banknotes. Professional storage solutions and conservation methods for long-term collection maintenance."
  },
  {
    title: "How to Spot Fake Ottoman Banknotes: Forgery Detection",
    keywords: [
      "fake Ottoman banknotes",
      "Turkish currency forgery detection",
      "counterfeit banknote identification",
      "Ottoman paper money authentication",
      "forgery prevention guide"
    ],
    description: "Learn to identify fake Ottoman Empire banknotes with expert forgery detection techniques. Protect your investment with professional authentication methods."
  }
];

// Canonical URL generation utilities
export const generateCanonicalURL = (path: string, baseUrl: string = 'https://ottocollect.com'): string => {
  // Remove trailing slash and add it back to ensure consistency
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const canonicalPath = cleanPath === '/' ? '' : cleanPath;
  return `${baseUrl}${canonicalPath}`;
};

export const getPageCanonicalURL = (pageType: string, params?: Record<string, string>): string => {
  const baseUrl = 'https://ottocollect.com';
  
  switch (pageType) {
    case 'home':
      return `${baseUrl}/`;
    case 'catalog':
      return `${baseUrl}/catalog`;
    case 'catalog-country':
      return `${baseUrl}/catalog/${encodeURIComponent(params?.country || '')}`;
    case 'marketplace':
      return `${baseUrl}/marketplace`;
    case 'collection':
      return `${baseUrl}/collection`;
    case 'forum':
      return `${baseUrl}/forum`;
    case 'blog':
      return `${baseUrl}/blog`;
    case 'blog-post':
      return `${baseUrl}/blog/${params?.id || ''}`;
    case 'community':
      return `${baseUrl}/community`;
    case 'about':
      return `${baseUrl}/about`;
    case 'contact':
      return `${baseUrl}/contact`;
    case 'banknote-detail':
      return `${baseUrl}/banknote-details/${params?.id || ''}`;
    case 'profile':
      return `${baseUrl}/profile/${params?.userId || ''}`;
    default:
      return `${baseUrl}${params?.path || ''}`;
  }
};

// SEO utility functions
export const generateBanknoteSEO = (banknote: any) => {
  const { country, denomination, year, extendedPickNumber, condition, price, currency } = banknote;
  
  return {
    title: `${denomination} ${country} Banknote ${year} - Authentic Historical Currency | OttoCollect`,
    description: `${denomination} ${country} banknote from ${year} (Pick #${extendedPickNumber}). ${condition ? `${condition} condition.` : ''} ${price ? `Price: ${price} ${currency}.` : ''} Rare historical currency for serious collectors.`,
    keywords: [
      `${country} banknote`,
      `${denomination} ${country}`,
      `${year} ${country} currency`,
      `Pick ${extendedPickNumber}`,
      'authentic Ottoman banknote',
      'historical Turkish currency',
      'rare paper money',
      'collector banknote'
    ],
    canonical: getPageCanonicalURL('banknote-detail', { id: banknote.id })
  };
};


export const generateCountrySEO = (country: string) => {
  return {
    title: `${country} Banknotes - Historical Currency Collection | OttoCollect`,
    description: `Browse authentic ${country} banknotes and historical currency. Rare collectible paper money from ${country} for serious numismatic collectors.`,
    keywords: [
      `${country} banknotes`,
      `${country} currency`,
      `${country} paper money`,
      `historical ${country} banknotes`,
      `rare ${country} currency`,
      'Ottoman Empire banknotes',
      'collectible currency'
    ],
    canonical: getPageCanonicalURL('catalog-country', { country })
  };
}; 